// i18next-extract-mark-ns-start common
import React from 'react';
import 'pure-react-carousel/dist/react-carousel.es.css';
import EventsPhoto from './EventPhoto';
import { Link } from 'gatsby';
import { Link as LocalizedLink } from '../LocalizedLink';
import { I18nextContext, useTranslation } from 'gatsby-plugin-react-i18next';
import { useContext } from 'react';

const EventCarousel = ({ data, slides, allButton, location }) => {
  const { t } = useTranslation();
  const context = useContext(I18nextContext);
  return (
    <div className="relative">
      <div className="relative mx-auto max-w-7xl">
        <div className="mx-auto grid max-w-lg gap-8 lg:max-w-none lg:grid-cols-3">
          {slides.map(item => (
            <div
              key={item.project.name}
              className="bg-white flex flex-col overflow-hidden rounded-2xl shadow-custom hover:scale-105 transition duration-500"
            >
              <div className="col-span-3 grid content-end">
                <EventsPhoto slides={item.gallery} height={60} />
              </div>
              <div className="flex flex-1 flex-col justify-between bg-white p-6">
                <div className="flex-1">
                  <p className="text-sm font-medium text-adw-blue">
                    {item.date}
                  </p>
                  <Link
                    to={
                      '/' +
                      context.language +
                      '/' +
                      item.project.kind +
                      item.project.uri
                    }
                    className="mt-2 block"
                  >
                    <p className="text-xl font-semibold text-gray-900">
                      {item.project.name}
                    </p>
                    <p className="mt-3 text-sm text-gray-500">{item.text}</p>
                  </Link>
                </div>
              </div>
            </div>
          ))}
          {allButton ? (
            <LocalizedLink
              to={'/events'}
              className="mx-auto lg:mx-0 rounded-3xl w-56 bg-adw-blue mt-5 py-3 px-6 text-center text-sm lg:text-base
        font-medium text-white shadow-md sm:inline-block hover:bg-white hover:border-adw-blue hover:text-adw-blue"
            >
              {t('Zobraziť všetky udalosti')}
            </LocalizedLink>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default EventCarousel;
